import React__default from "react";
import { Image } from "../../image/image.mjs";
import { ObjectFit } from "../../object-fit/object-fit.mjs";
const MainContext = React__default.createContext({
  hasMainPageComponent: false
});
const MainPage = (props) => {
  const { children, backgroundImage, className } = props;
  const BEM = () => {
    const classArray = ["main__page"];
    if (backgroundImage) {
      classArray.push("main__page--with-background");
    }
    if (className) {
      classArray.push(className);
    }
    return classArray.join(" ");
  };
  return /* @__PURE__ */ React__default.createElement("main", { className: BEM(), id: "main-content", tabIndex: -1 }, /* @__PURE__ */ React__default.createElement(MainContext.Provider, { value: React__default.useMemo(() => ({ hasMainPageComponent: true }), []) }, backgroundImage && /* @__PURE__ */ React__default.createElement("div", { className: "main__page--background" }, /* @__PURE__ */ React__default.createElement(ObjectFit, { fit: "cover", positionX: "center", positionY: "center" }, /* @__PURE__ */ React__default.createElement(Image, { ...backgroundImage, className: "main__page--background-image", pictureClassName: "main__page--background-picture", width: 500 }))), children));
};
export {
  MainContext,
  MainPage
};
